<template>
  <order-body :isOk="false" :codeStatus="500" :pageText="'orderRtw'">
  </order-body>
</template>

<script>
import orderBody from "_my/order-body";

export default {
  name: "orderRtw",
  components: {
    orderBody,
  },
};
</script>